import React from "react";
import AnnouncementBar from "../../../../components/AnnouncementBar/AnnouncementBar";
import VehicleMakeIndex from "../../../../components/SidetabPages/Catalog/VehicleMake/VehicleMakeIndex";

const VehicleMakes = () => {
  return (
    <>
      <AnnouncementBar />
      <VehicleMakeIndex />
    </>
  );
};
export default VehicleMakes;
